import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, Text, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { setMapSingleEventHandler } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';

export default class SelectLink2PolygonLayer extends VectorLayer {
    styleTest = new Style({
        stroke: new Stroke({
            color: 'rgba( 255, 255, 255, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 255, 0, 0, 0.7)'
        })
    });
    styleSelected = new Style({
        stroke: new Stroke({
            color: 'rgba( 255, 255, 255, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 60, 130, 255, 0.6)'
        })
    });
    styleLastSelected = new Style({
        stroke: new Stroke({
            color: 'rgba( 255, 255, 255, 1)',
            width: 2
        }),
        fill: new Fill({
            color: 'rgba( 70, 140, 255, 1)'
        })
    });
    styleFocus = new Style({
        stroke: new Stroke({
            color: 'rgba( 60, 130, 255, 0.9)',
            width: 2
        }),
        fill: new Fill({
            color: 'rgba( 60, 130, 255, 0.15)'
        })
    });
    styleNormal = new Style({
        stroke: new Stroke({
            color: 'rgba( 200, 200, 200, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 60, 130, 255, 0.2)'
        })
    });
    styleUnknown = new Style({
        stroke: new Stroke({
            color: 'rgba( 200, 200, 200, 0.9)',
            width: 2,
            lineDash: [4, 8],
        }),
        fill: new Fill({
            color: 'rgba( 200, 200, 200, 0.4)'
        })
    });
    styleGray = new Style({
        stroke: new Stroke({
            color: 'rgba( 200, 200, 200, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 200, 200, 200, 0.7)'
        })
    });
    styleGreen = new Style({
        stroke: new Stroke({
            color: 'rgba( 0, 255, 0, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 0, 255, 0, 0.7)'
        })
    });
    styleYellow = new Style({
        stroke: new Stroke({
            color: 'rgba( 255, 255, 50, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 255, 255, 50, 0.7)'
        })
    });
    styleRed = new Style({
        stroke: new Stroke({
            color: 'rgba( 255, 0, 0, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 255, 0, 0, 0.7)'
        })
    });
    styleTooltip = new Style({
        text: new Text({
            font: "12px Calibri,sans-serif",
            fill: new Fill({
                color: "rgba(255, 255, 255, 1)"
            }),
            backgroundFill: new Fill({
                color: "rgba(0, 0, 0, 0.7)"
            }),
            padding: [3, 3, 2, 6],
            textBaseline: "bottom",
            offsetY: -15
        }),
        image: new RegularShape({
            radius: 6,
            points: 3,
            angle: Math.PI,
            displacement: [0, 10],
            fill: new Fill({
                color: "rgba(0, 0, 0, 0.7)"
            })
        }),
        geometry: new Point([]),
        zIndex: 1
    });

    constructor(map, data, mapProjection) {
        super({
            name: 'link2',
            source: new VectorSource({
                features: new GeoJSON({ featureProjection: mapProjection }).readFeatures(data),
                // url: '/api/GeoJson/LINK2',
                // format: new GeoJSON()
            }),
            style: (feature) => this.styleFunction(feature)
        });
        this.map = map;
    }

    styleFunction = function (feature) {
        const test = feature.get('test');
        const selected = feature.get('selected');
        const name = feature.get('name');
        if (feature.get('coordinate')) {
            this.styleTooltip.getGeometry().setCoordinates(feature.get('coordinate'));
            if (name) {
                const fname = feature.get('fname');
                const tname = feature.get('tname');
                this.styleTooltip.getText().setText(`${name}\n(${fname}-${tname})`);
                if (test)
                    return [this.styleTest, this.styleTooltip];
                return [selected ? this.getLastSelectStyle(feature) : this.styleFocus, this.styleTooltip];
            } else {
                this.styleTooltip.getText().setText(`정보없음\n(${feature.get('LINK2_ID')})`);
                return [this.styleUnknown, this.styleTooltip];
            }
        }

        if (test)
            return this.styleTest;
        return name ? (selected ? this.getLastSelectStyle(feature) : this.styleNormal) : this.styleUnknown;
    };

    getLastSelectStyle = (feature) => {
        // return this.lastSelectedFeature?.get('LINK2_ID') === feature.get('LINK2_ID') ? this.styleLastSelected : this.styleSelected
        // 단일 선택 모드이므로 윚 줄을 주석처리하고, 무조건 강한색을 return
        return this.styleLastSelected;
    }

    setTooltipMode = (isEnable) => {
        setMapSingleEventHandler(this.map, this, 'pointermove', isEnable ? (e, feature) => {
            if (feature) {
                const name = feature.get('name');
                let text = undefined;
                //도로별 교통량 이름 시작-끝 팝업 툴팁 나오는 위치
                if (name) {
                    const fname = feature.get('fname');
                    const tname = feature.get('tname');
                    const volume = feature.get('volume');
                    const speed = parseFloat(feature.get('speed'));
                    const yyyy = feature.get('yyyy');
                    const mm = feature.get('mm');
                    const dd = feature.get('dd');
                    const hh = feature.get('hh');
                    text = (`도로명 : ${name}\n(${fname}-${tname})\n평균속도 : ${speed} km/h\n${yyyy}년 ${mm}월 ${dd}일 ${hh}시 기준`);
                } else {
                    text = (`정보없음\n(${feature.get('LINK2_ID')})`);
                }
                this.map.tooltipLayer?.setTooltip(e.coordinate, text, feature)
            } else {
                this.map.tooltipLayer?.unsetTooltip();
            }
        } : undefined);
    }

    intersectionSelect = (id) => {
        this.getSource()?.forEachFeature(feature => {
            if (feature.get('fid') === id || feature.get('tid') === id) {
                feature.set('selected', true)
                this.lastSelectedFeature = null;
                this.lastSelectedDirection = null;
            }
        });
        this.setOnChangeSelectCall()
    }

    setSelectedMode = (isEnable) => {
        this.setDeSelectAll();
        this.makeLink2HashTable();
        setMapSingleEventHandler(this.map, this, 'click', isEnable ? (e, feature) => {
            if (feature?.get('selected')) {
                feature?.unset('selected');
                this.lastSelectedFeature = null;
                this.lastSelectedDirection = null;
            }
            else if (feature) {
                const lastSelectedFeature = this.lastSelectedFeature;
                const lastSelectedDirection = this.lastSelectedDirection;
                if (lastSelectedFeature) {
                    const searchFid = lastSelectedFeature.get('fid');
                    const searchTid = lastSelectedFeature.get('tid');
                    const arr = [];

                    if (lastSelectedDirection) {
                        this.findHashTableLink2(arr, feature, searchFid, searchTid, [], lastSelectedDirection)
                    } else {
                        this.findHashTableLink2(arr, feature, searchFid, searchTid, [], 'f')
                        this.findHashTableLink2(arr, feature, searchFid, searchTid, [], 't')
                    }
                    //길이가 적은 경로를 우선으로 정렬
                    arr.sort(function (a, b) {
                        const aLen = a.results.reduce((total, obj) => total + (obj.get('len') || 0), 0);
                        const bLen = b.results.reduce((total, obj) => total + (obj.get('len') || 0), 0);
                        if (aLen > bLen) return 1;
                        if (aLen < bLen) return -1;
                        return 0;
                    });
                    if (arr.length > 0) {
                        arr[0].results.map(f => f.set('selected', true));
                        this.lastSelectedDirection = arr[0].direction
                    } else {
                        //찾은 경로없음
                        this.onRouteFindErrorAction("잘못된 경로이거나 먼 거리입니다.")
                        return;
                    }
                }

                feature.set('selected', true);
                this.lastSelectedFeature = feature;
            }

            this.setOnChangeSelectCall()

        } : undefined);
    }

    setSingleSelectedMode = (isEnable) => {
        this.setDeSelectAll();
        setMapSingleEventHandler(this.map, this, 'click', isEnable ? (e, feature) => {
            if (feature?.get('selected')) {
                feature?.unset('selected');
                this.lastSelectedFeature = null;
            } 
            else if (feature) {
                this.getSource()?.forEachFeature(f => f.unset('selected'));
                feature.set('selected', true);
                this.lastSelectedFeature = feature;
            }
            this.setOnChangeSelectCall();
        } : undefined);
    }

    setDeSelectAll = () => {
        this.getSource()?.forEachFeature(feature => {
            feature.unset('selected');
        });
        this.lastSelectedFeature = null;
        this.lastSelectedDirection = null;

        if (this.onChangeSelectAction)
            this.onChangeSelectAction({ features: {}, count: 0, length: 0 });
    }

    setOnChangeSelectCall = () => {
        if (this.onChangeSelectAction) {
            let features = {};
            let cnt = 0;
            let len = 0;
            this.getSource()?.forEachFeature(feature => {
                if (feature.get('selected')) {
                    features[feature.get("LINK2_ID")] = feature;
                    len += feature.get('len');
                    cnt++;
                }
            });
            this.onChangeSelectAction({ features, count: cnt, length: len });
        }
    }

    setOnChangeSelectBind = (action) => {
        this.onChangeSelectAction = action
    }

    setOnRouteFindErrorBind = (action) => {
        this.onRouteFindErrorAction = action
    }

    makeLink2HashTable = () => {
        const table = { fid: {}, tid: {} }
        this.getSource()?.forEachFeature(feature => {
            const fid = feature.get('fid');
            if (!table.fid[fid])
                table.fid[fid] = [];

            table.fid[fid].push(feature);

            const tid = feature.get('tid');
            if (!table.tid[tid])
                table.tid[tid] = [];

            table.tid[tid].push(feature);
        });

        this.link2HashTable = table;
    }
    findHashTableLink2 = (arr, startFeature, searchFid, searchTid, results = [], direction = undefined, tryCount = 0) => {
        if (tryCount > 10)
            return;

        const fid = startFeature.get('fid');
        const tid = startFeature.get('tid');

        if (fid === searchTid && tid === searchFid) // 반대차로 제외
            return;

        if ((direction === 'f' && fid === searchTid) ||
            (direction === 't' && tid === searchFid)) {
            arr.push({ direction, results });
            return;
        }

        if (direction === 'f') {
            const features = this.link2HashTable.tid[fid];
            features?.map(feature => {
                if (fid !== feature.get('tid') || tid !== feature.get('fid')) // 반대차로 제외
                    this.findHashTableLink2(arr, feature, searchFid, searchTid, [...results, feature], 'f', tryCount + 1)
                return undefined
            })
        }
        else {
            const features = this.link2HashTable.fid[tid];
            features?.map(feature => {
                if (fid !== feature.get('tid') || tid !== feature.get('fid')) // 반대차로 제외
                    this.findHashTableLink2(arr, feature, searchFid, searchTid, [...results, feature], 't', tryCount + 1)
                return undefined
            })
        }
    }

    flash = (map, feature) => {
        const duration = 1500;
        const start = Date.now();;
        const flashGeom = feature.getGeometry().clone()
        const listenerKey = this.on('postrender', animate);

        const style = new Style({
            stroke: new Stroke({
                color: 'rgba( 60, 130, 255, 0.9)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba( 60, 130, 255, 0.15)'
            })
        });

        function animate(event) {
            const frameState = event.frameState;
            const elapsed = frameState.time - start;
            if (elapsed >= duration) {
                unByKey(listenerKey);
                return;
            }
            const vectorContext = getVectorContext(event);
            const elapsedRatio = elapsed / duration;
            // radius will be 5 at start and 30 at end.
            const opacity = 1 - elapsedRatio//easeOut(1 - elapsedRatio);
            style.getStroke().setColor(`rgba(60, 130, 255, ${opacity})`);

            vectorContext.setStyle(style);
            vectorContext.drawGeometry(flashGeom);
            // tell OpenLayers to continue postrender animation
            map.render();
        }
    }
}